import React, { Component } from 'react'
import { connect } from 'react-redux'

import RaisedButton from 'material-ui/RaisedButton'

import FormHeader from 'components/FormHeader'
import ReportSelect from './ReportSelect'
import PeriodSelect from './PeriodSelect'
import PropertySelect from './PropertySelect'
import Download from './Download'
import Report from './Report'

export default class Finances extends Component{
	render(){
		let { props } = this
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>
				<FormHeader
					title={
						<div style={{display: "flex", justifyContent: "space-between"}}>
							<div style={{display: "flex"}}>
								<ReportSelect />
								<PeriodSelect />
							</div>
							<div>
								<Download />
							</div>
						</div>
					}
					masterDetail={false}
				/>
				<main style={{width: "70%", margin: "0 auto"}}>
					<Report />
				</main>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/index.js